
  import { mapState } from 'vuex'
  export default {
    name: 'Theme2MobileBalanceDropdown',
    data() {
      return {
        selectedWalletId: 'fiat'
      }
    },
    computed: {
      ...mapState({
        player: state => state.player.player,
        onHoldWallet: state => state.player.onHoldWallet,
        activityWallet: state => state.player.activityWallet,
        missionsSettings: state => state.activities['mission-reward'].missionsSettings
      }),
      walletList() {
        return [
          {
            title: this.tl('mainWallet'),
            amount: this.playerRealtimeBalance(),
            src: false,
            currency: this.player.currency,
            color: 'success',
            colorText: 'success--text',
            type: 'fiat',
            status: true
          },
          {
            title: this.tl('onHoldWallet'),
            amount: this.onHoldWallet,
            src: false,
            currency: this.player.currency,
            color: '#ddaf3e',
            colorText: 'primary--text',
            type: 'on-hold',
            status: true
          },
          {
            title: this.getMissionCoinName(this.missionsSettings),
            amount: this.activityWallet,
            src: this.missionsSettings,
            type: 'coin',
            colorText: 'primary--text',
            status: this.missionsSettings?.status
          }
        ]
      },
      selectedWalletData() {
        const findSelectedWallet = this.walletList.find(
          wallet => wallet.type === this.selectedWalletId
        )
        return findSelectedWallet || {}
      }
    },
    methods: {
      onSelectWallet(walletId) {
        this.selectedWalletId = walletId
      }
    }
  }
